import { RuleSet } from 'ngx-angular-query-builder';

export class FilterEditorDialogResult
{
  filter: RuleSet;
}
